var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgEdit = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-624 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.977,187.023a1,1,0,0,1-.991-1.142l.355-2.474a1,1,0,0,1,.283-.566l9.131-9.132a2.563,2.563,0,0,1,3.536,0,2.5,2.5,0,0,1,0,3.535l-9.133,9.132a.989.989,0,0,1-.565.283l-2.476.354A.974.974,0,0,1,629.977,187.023Zm2.475-1.354h0Zm-1.179-1.649-.118.824.825-.117,8.9-8.9a.5.5,0,0,0-.708-.707ZM642,186a1,1,0,0,0-1-1h-4a1,1,0,0,0,0,2h4A1,1,0,0,0,642,186Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.d292c884.svg";
export { ForwardRef as ReactComponent };